module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-10": "",
      "is-offset-1": ""
    }
  }, [_c('columns', [_c('column', [_c('notification', {
    attrs: {
      "is-info": ""
    },
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("First column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-success": ""
    }
  }, [_vm._v("Second column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-warning": ""
    }
  }, [_vm._v("Third column")])], 1), _vm._v(" "), _c('column', [_c('notification', {
    attrs: {
      "is-danger": ""
    }
  }, [_vm._v("Fourth column")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a02ecd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/example/grid.vue
// module id = 15
// module chunks = 0